<div class="table-responsive mt-3">
  <table class="table table-default services-table mb-0">
    <thead>
    <tr>
      <th class="name">{{ 'SERVICE_SELECTION_MODAL.TABLE.NAME' | translate }}</th>
      <th class="descr">{{ 'SERVICE_SELECTION_MODAL.TABLE.DESCRIPTION' | translate }}</th>
      <th>{{ 'SERVICE_SELECTION_MODAL.TABLE.PRICE' | translate }}</th>
      <th *ngIf="atLeastOneHaveComment(services)">{{ 'SERVICE_SELECTION_MODAL.TABLE.COMMENT' | translate }}</th>
      <th width="100px"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let serviceObj of services">
      <td class="name">{{serviceObj.name}}</td>
      <td class="text-left descr">
        <div *ngFor="let descr of serviceObj.descriptions">
          {{ descr }}
        </div>
      </td>
      <td>
        <ng-container
          *ngIf="serviceObj.price.consumer.total > 0">{{ serviceObj.price.consumer.total | number :'1.2-2' }}
          {{ serviceObj.price.consumer.currency }}
        </ng-container>
        <ng-container *ngIf="serviceObj.price.consumer.total == 0">{{ 'SERVICE_SELECTION_MODAL.TABLE.FREE' | translate }}</ng-container>
      </td>
      <td *ngIf="atLeastOneHaveComment(services)">
        <ng-container *ngIf="showCommentInput(serviceObj, passengerRef)">
          <ng-container *ngFor="let selectedService of selectedServicesCopy; let index = idx; trackBy: trackByService">
            <ng-container *ngIf="isMatchingService(serviceObj, passengerRef, selectedService)">
              <div class="form-group-sm d-flex flex-column gap-8">
                <ng-container *ngFor="let instruction of serviceObj.bookingInstructions.instructions; let idx = index">
                  <div>
                    <label class="w-100 text-left">{{instruction.text}}:</label>
                    <input class="form-control"
                           [value]="getServiceValue(serviceObj, passengerRef, idx)"
                           [type]="instruction.type"
                           [placeholder]="instruction.text"
                           [pattern]="instruction.pattern"
                           (input)="handleCommentInput($event, serviceObj, passengerRef, instruction, idx)">
                    <span class="error"
                          *ngIf="validationErrors[serviceObj.serviceID + passengerRef + serviceObj.segmentReferences + idx]">
                    {{ validationErrors[serviceObj.serviceID + passengerRef + serviceObj.segmentReferences + idx] }}
                </span>
                  </div>
                </ng-container>
              </div>

              <div>
                <label for="serviceText" class="w-100 text-left">Text to be sent:</label>
                <textarea class="form-control mh-80"
                          id="serviceText"
                          [(ngModel)]="selectedService.text"
                          (focus)="storeFieldByFieldText(selectedService)"
                          (input)="adjustTextareaHeight($event, selectedService)"></textarea>
                <div *ngIf="serviceObj.bookingInstructions?.pattern">Pattern: {{serviceObj.bookingInstructions.pattern}}</div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </td>
      <td>
        <ng-container *ngIf="serviceObj.ref != 'Seat'">
          <ng-container
            *ngIf="selectedServicesMapCopy[serviceObj.serviceID + passengerRef + serviceObj.segmentReferences]">
              <span
                (click)="toggleServiceSelection(serviceObj, passengerRef)"
                class="btn btn-sm btn-tonal-primary mw-74">
                {{ 'SERVICE_SELECTION_MODAL.TABLE.SELECTED' | translate }}
              </span>
          </ng-container>

          <ng-container
            *ngIf="!selectedServicesMapCopy[serviceObj.serviceID + passengerRef + serviceObj.segmentReferences]">
              <span
                (click)="toggleServiceSelection(serviceObj, passengerRef)"
                class="btn btn-sm btn-outline-primary mw-74">
                {{ 'SERVICE_SELECTION_MODAL.TABLE.SELECT' | translate }}
              </span>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="serviceObj.ref == 'Seat'">
          {{ 'SERVICE_SELECTION_MODAL.TABLE.TEMP_DISABLED' | translate }}
        </ng-container>
      </td>
    </tr>
    </tbody>
  </table>
</div>
